import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatDateYearMonthDay',
  standalone: true
})
/**
 * 將 yyyyMMdd 格式(例如:20240102)轉換為 yyyy 年 M 月 d 日(例如:2024 年 1 月 2 日)
 */
export class FormatDateYearMonthDayPipe implements PipeTransform {
  transform(value: string): string {
    if (!/^\d{8}$/.test(value)) {
      return '';
    }

    const year = value.substring(0, 4);
    const month = parseInt(value.substring(4, 6), 10); // 去掉前導零
    const day = parseInt(value.substring(6, 8), 10);   // 去掉前導零

    return `${year} 年 ${month} 月 ${day} 日`;
  }
}